import React from 'react';
import usePageVisibility from '../usePageVisibility';

export const ContractStateContext = React.createContext({});
export const ContractDispatchContext = React.createContext(() => {});
export const ContractStoreContext = React.createContext({});

export const businessContractId__ = 'businessContractId';
export const scanContractId__ = 'scanContractId';
const getState = (store) => {
    const state = {
        businessContractId: store.get(businessContractId__),
        scanContractId: store.get(scanContractId__)
    };
    return state;
};

export const ContractProvider = React.memo(({children, store}) => {
    const [state, setState] = React.useState(() => getState(store));
    const onVisibilityChange = React.useCallback((visible) => {
        if (visible) {
            setState(getState(store));
        }
    }, []);
    usePageVisibility(onVisibilityChange);
    const dispatch = React.useCallback(() => {
        setState(getState(store));
    }, []);
    return (
        <ContractStoreContext.Provider value={store}>
            <ContractStateContext.Provider value={state}>
                <ContractDispatchContext.Provider value={dispatch}>
                    {children}
                </ContractDispatchContext.Provider>
            </ContractStateContext.Provider>
        </ContractStoreContext.Provider>
    );
});

export const useContractState = () => React.useContext(ContractStateContext);
export const useContractDispatch = () => React.useContext(ContractDispatchContext);
export const useContractStore = () => React.useContext(ContractStoreContext);